//@ts-check

class LevyRollService {
	constructor(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		FinancialsService,
		LocalStorageService,
		InternalLinksService
	) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.FinancialsService = FinancialsService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.numberOfResults = 0;
		this.numberOfResultsLegal = 0;
		this.levyRollData = undefined;
	}

	async getLevyRoll(schemeRef, date, sortByUnitNumber, showOnlyDebt, showLegalMemos, showAllLegalAccounts, pageNumber) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('FinancialApiLevyRoll');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiLevyRoll');
			}

			date = this.FinancialsService.getMapFirstDay(date);
			url = url.replace('{schemeRef}', schemeRef).trim();
			url += `?date=${moment(date).format(
				'L'
			)}&sortByUnitNumber=${sortByUnitNumber}&showOnlyDebt=${showOnlyDebt}&showLegalMemos=${showLegalMemos}&showAllLegalAccounts=${showAllLegalAccounts}&pageNumber=${pageNumber}`;

			const headers = this.Utility.headersWithContentType;

			if (!!!headers || (!!headers && (!!!headers.userName || !!!headers.sessionToken))) {
				const error = `Could not load Levy as the 'Username' and/or 'Session Token' is missing`;
				this.$timeout(() => promiseHandler.reject(error));
			}

			const results = await this.$http.get(url, { headers: headers });
            const { data } = results;
            var totalLeviesBilled = 0;
            for (var i = 0; i < data.SummaryOfReceipts.length; i++) {
                totalLeviesBilled += data.SummaryOfReceipts[i].Amount;
            }
            data.SummaryOfReceipts.push({
                Amount: totalLeviesBilled,
                Description: "Total Levies Billed"
            });

			this.levyRollData = data;
			this.numberOfResults = data.NumberOfResults;
			this.numberOfResultsLegal = data.NumberOfResultsLegal;
			this.$timeout(() => promiseHandler.resolve());
		} catch (error) {
			this.levyRollData = [];
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async getUnitLegalMemo(CardCode, date, UnitItemCode) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('FinancialApiLevyRollMemo');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/financial/links');
				url = await this.InternalLinksService.getLink('FinancialApiLevyRollMemo');
			}
			
			date = this.FinancialsService.getMapFirstDay(date);
			url = url.replace('{CardCode}', CardCode).trim();
			url += `?date=${moment(date).format(
				'L'
			)}`;

			const headers = this.Utility.headersWithContentType;

			const results = await this.$http.get(url, { headers: headers });
			const { data } = results;
			this.levyRollUnitMemoData = data.Data;
			this.$timeout(() => promiseHandler.resolve());
		} catch (error) {
			this.levyRollUnitMemoData = [];
			this.$timeout(() => promiseHandler.reject(error));
		}
		return promise
	}
}

export default /* @ngInject */ (
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	FinancialsService,
	LocalStorageService,
	InternalLinksService
) =>
	new LevyRollService(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		FinancialsService,
		LocalStorageService,
		InternalLinksService
	);
